<template>
  <div class="container flex-column">

    <div class="header flex-column">
      <h1>Cyberdine conseil</h1>
      <h1 class="thin">Ingénierie & systèmes</h1>

      <img src="../../img/ingenierie/triangle.svg" alt="">
    </div>

    <div class="texte flex-row-space-evenly">
      <p>
        Société de conseil en ingénierie, nous assistons nos clients sur chaque jalon de leurs projets.<br>
        De la conception de systèmes et architecture réseaux en bureau d’étude, à la conduite de travaux,<br>
        nous intervenons au cœur des procédés de déploiement et de l’exploitation des infrastructures.
      </p>
    </div>

    <div class="table flex-row-wrap">
      <div class="photo photo-1 length-2" @click="open(1)"><div class="overlay-black"><p>Accompagnement</p></div></div>
      <div class="photo photo-2 length-2" @click="open(2)"><div class="overlay-black"><p>Expertise</p></div></div>
      <div class="photo photo-3 length-2" @click="open(3)"><div class="overlay-black"><p>Formation</p></div></div>
      <div class="photo photo-4 length-2" @click="open(4)"><div class="overlay-black"><p>Veille Technologique</p></div></div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
        open(photoId) {
            this.$emit('openImage', photoId);
        }
    }
  }
</script>

<style scoped>
  .container {
    width: 100%;
    padding-bottom: 20px;
  }

  .header {
    height: 160px;

    position: relative;
  }
  .header h1 {
    margin: 0;
    text-transform: uppercase;
    color: #162139;
    font-weight: 700;
  }
  .header h1.thin {
    font-weight: 100;
  }
  .header img {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 25px;
  }

  .container > .texte {
    width: 100%;
    padding: 20px 0;
  }
  .container > .texte p {
    width: 90%;
    color: #9596bd;
    font-size: 20px;
  }

  .table {
    width: 90%;
  }
  .table .photo {
    height: 400px;
    margin: 10px;
    background-size: cover;
  }
  .table .length-1 {
    width: calc(25% - 20px);
    min-width: 300px;
  }
  .table .length-2 {
    width: calc(50% - 20px);
    min-width: 620px;
  }

  .photo-1 {
    background: url("../../img/ingenierie/reduct/reduct_Accompagnement.jpg") no-repeat center center;
  }
  .photo-2 {
    background: url("../../img/ingenierie/reduct/reduct_Expertise.jpg") no-repeat center center;
  }
  .photo-3 {
    background: url("../../img/ingenierie/reduct/reduct_Formation.jpg") no-repeat center center;
  }
  .photo-4 {
    background: url("../../img/ingenierie/reduct/reduct_Veille_Technologique.jpg") no-repeat center center;
  }

  .photo .overlay-black {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 25px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    opacity: 0;
  }
  .photo:hover .overlay-black {
    opacity: 1;
  }

  @media (max-width: 1430px) and (min-width: 701px) {
    .length-1 {
      width: calc(50% - 20px) !important;
      min-width: 0 !important;
    }
    .length-2 {
      width: calc(100% - 20px) !important;
      min-width: 0 !important;
    }
    .group {
      width: 100%;
    }
  }

  @media (max-width: 700px) {
    .length-1 {
      width: calc(100% - 20px) !important;
      min-width: 0 !important;
    }
    .length-2 {
      width: calc(100% - 20px) !important;
      min-width: 0 !important;
    }
    .group {
      width: 100%;
    }
    .texte p {
      font-size: 18px !important;
      color: #9596bd !important;
    }
    .header {
      height: auto;
      margin-top: 40px;
    }
    .header img {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/Ingenierie.vue